import Route from '@ember/routing/route';

export default class AuthenticatedCareerPathwaysRoute extends Route {}
